var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var StrategyDisplayMode = /* @__PURE__ */ ((StrategyDisplayMode2) => {
  StrategyDisplayMode2["TOTAL"] = "total";
  StrategyDisplayMode2["INVEST_HISTORY"] = "investHistory";
  StrategyDisplayMode2["ORDER_HISTORY"] = "orderHistory";
  return StrategyDisplayMode2;
})(StrategyDisplayMode || {});
var CompareResultType = /* @__PURE__ */ ((CompareResultType2) => {
  CompareResultType2[CompareResultType2["ABOVE"] = 1] = "ABOVE";
  CompareResultType2[CompareResultType2["EQUAL_OR_INSIDE"] = 0] = "EQUAL_OR_INSIDE";
  CompareResultType2[CompareResultType2["BELOW"] = -1] = "BELOW";
  return CompareResultType2;
})(CompareResultType || {});
var OhlcvIndex = /* @__PURE__ */ ((OhlcvIndex2) => {
  OhlcvIndex2[OhlcvIndex2["TIME"] = 0] = "TIME";
  OhlcvIndex2[OhlcvIndex2["OPEN"] = 1] = "OPEN";
  OhlcvIndex2[OhlcvIndex2["HIGH"] = 2] = "HIGH";
  OhlcvIndex2[OhlcvIndex2["LOW"] = 3] = "LOW";
  OhlcvIndex2[OhlcvIndex2["CLOSE"] = 4] = "CLOSE";
  OhlcvIndex2[OhlcvIndex2["VOLUME"] = 5] = "VOLUME";
  OhlcvIndex2[OhlcvIndex2["QUOTE_VOLUME"] = 6] = "QUOTE_VOLUME";
  OhlcvIndex2[OhlcvIndex2["TAKER_BUY_VOLUME"] = 7] = "TAKER_BUY_VOLUME";
  return OhlcvIndex2;
})(OhlcvIndex || {});
var SourceIndex = /* @__PURE__ */ ((SourceIndex2) => {
  SourceIndex2[SourceIndex2["HL"] = 0] = "HL";
  SourceIndex2[SourceIndex2["HLC"] = 1] = "HLC";
  SourceIndex2[SourceIndex2["OHLC"] = 2] = "OHLC";
  SourceIndex2[SourceIndex2["HLCC"] = 3] = "HLCC";
  return SourceIndex2;
})(SourceIndex || {});
var OrderTypeCcxt = /* @__PURE__ */ ((OrderTypeCcxt2) => {
  OrderTypeCcxt2["LIMIT"] = "limit";
  OrderTypeCcxt2["MARKET"] = "market";
  return OrderTypeCcxt2;
})(OrderTypeCcxt || {});
var OrderSideCcxt = /* @__PURE__ */ ((OrderSideCcxt2) => {
  OrderSideCcxt2["BUY"] = "buy";
  OrderSideCcxt2["SELL"] = "sell";
  return OrderSideCcxt2;
})(OrderSideCcxt || {});
var SubTypeCcxt = /* @__PURE__ */ ((SubTypeCcxt2) => {
  SubTypeCcxt2["LINEAR"] = "linear";
  SubTypeCcxt2["INVERSE"] = "inverse";
  return SubTypeCcxt2;
})(SubTypeCcxt || {});
var TakerOrMaker = /* @__PURE__ */ ((TakerOrMaker2) => {
  TakerOrMaker2["TAKER"] = "taker";
  TakerOrMaker2["MAKER"] = "maker";
  return TakerOrMaker2;
})(TakerOrMaker || {});
var MarketTypeCcxt = /* @__PURE__ */ ((MarketTypeCcxt2) => {
  MarketTypeCcxt2["SPOT"] = "spot";
  MarketTypeCcxt2["MARGIN"] = "margin";
  MarketTypeCcxt2["SWAP"] = "swap";
  MarketTypeCcxt2["FUTURE"] = "future";
  MarketTypeCcxt2["OPTION"] = "option";
  MarketTypeCcxt2["DELIVERY"] = "delivery";
  MarketTypeCcxt2["INDEX"] = "index";
  return MarketTypeCcxt2;
})(MarketTypeCcxt || {});
var CandleValueType = /* @__PURE__ */ ((CandleValueType2) => {
  CandleValueType2["OPEN"] = "open";
  CandleValueType2["HIGH"] = "high";
  CandleValueType2["LOW"] = "low";
  CandleValueType2["CLOSE"] = "close";
  CandleValueType2["VOLUME"] = "volume";
  CandleValueType2["TAKER_BUY_VOLUME"] = "takerBuyVolume";
  return CandleValueType2;
})(CandleValueType || {});
var CandleComputedType = /* @__PURE__ */ ((CandleComputedType2) => {
  CandleComputedType2["CLOSE_OPEN_DELTA"] = "openCloseDelta";
  CandleComputedType2["CLOSE_OPEN_DELTA_ABSOLUTE"] = "openCloseDeltaAbsolute";
  CandleComputedType2["CLOSE_OPEN_DELTA_PERCENT"] = "openCloseDeltaPercent";
  CandleComputedType2["CLOSE_OPEN_DELTA_PERCENT_ABSOLUTE"] = "openCloseDeltaPercentAbsolute";
  CandleComputedType2["HIGH_LOW_DELTA"] = "lowHighDelta";
  CandleComputedType2["HIGH_LOW_DELTA_PERCENT"] = "lowHighDeltaPercent";
  CandleComputedType2["CLOSE_LOW_DELTA"] = "lowCloseDelta";
  CandleComputedType2["CLOSE_LOW_DELTA_PERCENT"] = "lowCloseDeltaPercent";
  CandleComputedType2["CLOSE_HIGH_DELTA"] = "highCloseDelta";
  CandleComputedType2["CLOSE_HIGH_DELTA_PERCENT"] = "highCloseDeltaPercent";
  CandleComputedType2["HL"] = "hl";
  CandleComputedType2["HLC"] = "hlc";
  CandleComputedType2["OHLC"] = "ohlc";
  CandleComputedType2["HLCC"] = "hlcc";
  return CandleComputedType2;
})(CandleComputedType || {});
const CandleConditionTypes = { ...CandleValueType, ...CandleComputedType };
const candleValuesSet = new Set(Object.values(CandleValueType));
const isCandleValueType = /* @__PURE__ */ __name((type) => {
  return candleValuesSet.has(type);
}, "isCandleValueType");
const isCandleComputedType = /* @__PURE__ */ __name((type) => {
  return !candleValuesSet.has(type);
}, "isCandleComputedType");
var ConditionOperatorType = /* @__PURE__ */ ((ConditionOperatorType2) => {
  ConditionOperatorType2["EQUAL"] = "equal";
  ConditionOperatorType2["NOT_EQUAL"] = "notEqual";
  ConditionOperatorType2["CROSSING"] = "crossing";
  ConditionOperatorType2["CROSSING_UP"] = "crossingUp";
  ConditionOperatorType2["CROSSING_DOWN"] = "crossingDown";
  ConditionOperatorType2["GREATER_THAN"] = "greaterThan";
  ConditionOperatorType2["EQUAL_OR_GREATER_THAN"] = "equalOrGreaterThan";
  ConditionOperatorType2["LESS_THAN"] = "lessThan";
  ConditionOperatorType2["EQUAL_OR_LESS_THAN"] = "equalOrLessThan";
  ConditionOperatorType2["CLOSER"] = "closer";
  ConditionOperatorType2["EQUAL_OR_CLOSER"] = "equalOrCloser";
  ConditionOperatorType2["FARTHER"] = "farther";
  ConditionOperatorType2["EQUAL_OR_FARTHER"] = "equalOrFarther";
  ConditionOperatorType2["ENTERING_CHANNEL"] = "enteringChannel";
  ConditionOperatorType2["EXITING_CHANNEL"] = "exitingChannel";
  ConditionOperatorType2["INSIDE_CHANNEL"] = "insideChannel";
  ConditionOperatorType2["OUTSIDE_CHANNEL"] = "outsideChannel";
  ConditionOperatorType2["WEBHOOK"] = "webhook";
  return ConditionOperatorType2;
})(ConditionOperatorType || {});
var OperandSourceType = /* @__PURE__ */ ((OperandSourceType2) => {
  OperandSourceType2["OHLCV"] = "ohlcv";
  OperandSourceType2["INDICATOR"] = "indicator";
  OperandSourceType2["VALUE"] = "value";
  OperandSourceType2["FORMULA"] = "formula";
  OperandSourceType2["SHAPE"] = "shape";
  OperandSourceType2["WEBHOOK"] = "webhook";
  return OperandSourceType2;
})(OperandSourceType || {});
var AlertFrequencyType = /* @__PURE__ */ ((AlertFrequencyType2) => {
  AlertFrequencyType2["REALTIME"] = "realtime";
  AlertFrequencyType2["ONLY_ONCE"] = "onlyOnce";
  AlertFrequencyType2["ONLY_PER_BAR"] = "onlyPerBar";
  AlertFrequencyType2["ONLY_PER_BAR_CLOSE"] = "onlyPerBarClose";
  AlertFrequencyType2["ONLY_PER_MINUTE"] = "onlyPerMinute";
  return AlertFrequencyType2;
})(AlertFrequencyType || {});
var MAType = /* @__PURE__ */ ((MAType2) => {
  MAType2[MAType2["Sma"] = 0] = "Sma";
  MAType2[MAType2["Ema"] = 1] = "Ema";
  MAType2[MAType2["Wma"] = 2] = "Wma";
  MAType2[MAType2["Dema"] = 3] = "Dema";
  MAType2[MAType2["Tema"] = 4] = "Tema";
  MAType2[MAType2["Trima"] = 5] = "Trima";
  MAType2[MAType2["Kama"] = 6] = "Kama";
  MAType2[MAType2["Mama"] = 7] = "Mama";
  MAType2[MAType2["T3"] = 8] = "T3";
  return MAType2;
})(MAType || {});
function getMaTypeName(type) {
  switch (type) {
    case 0 /* Sma */:
      return "SMA";
    case 1 /* Ema */:
      return "EMA";
    case 2 /* Wma */:
      return "WMA";
    case 3 /* Dema */:
      return "DEMA";
    case 4 /* Tema */:
      return "TEMA";
    case 8 /* T3 */:
      return "T3";
    case 5 /* Trima */:
      return "TRIMA";
    case 6 /* Kama */:
      return "KAMA";
    case 7 /* Mama */:
      return "MAMA";
    default:
      return "";
  }
}
__name(getMaTypeName, "getMaTypeName");
var IndicatorSeriesType = /* @__PURE__ */ ((IndicatorSeriesType2) => {
  IndicatorSeriesType2["AREA"] = "area";
  IndicatorSeriesType2["ALTAREA"] = "altarea";
  IndicatorSeriesType2["LINE"] = "line";
  IndicatorSeriesType2["BAR"] = "bar";
  IndicatorSeriesType2["ALTBAR"] = "altbar";
  IndicatorSeriesType2["CANDLE"] = "candle";
  IndicatorSeriesType2["ALTLINE"] = "altline";
  return IndicatorSeriesType2;
})(IndicatorSeriesType || {});
var EditMode = /* @__PURE__ */ ((EditMode2) => {
  EditMode2["ADD"] = "add";
  EditMode2["EDIT"] = "edit";
  EditMode2["DELETE"] = "delete";
  return EditMode2;
})(EditMode || {});
var IndicatorOrCondition = /* @__PURE__ */ ((IndicatorOrCondition2) => {
  IndicatorOrCondition2["INDICATOR"] = "indicator";
  IndicatorOrCondition2["CONDITION"] = "condition";
  return IndicatorOrCondition2;
})(IndicatorOrCondition || {});
var PositionType = /* @__PURE__ */ ((PositionType2) => {
  PositionType2["LONG"] = "long";
  PositionType2["SHORT"] = "short";
  return PositionType2;
})(PositionType || {});
var OrderType = /* @__PURE__ */ ((OrderType2) => {
  OrderType2["ENTER"] = "enter";
  OrderType2["EXIT"] = "exit";
  return OrderType2;
})(OrderType || {});
var PositionOrderType = /* @__PURE__ */ ((PositionOrderType2) => {
  PositionOrderType2["LONG_ENTER"] = `long_enter`;
  PositionOrderType2["LONG_EXIT"] = `long_exit`;
  PositionOrderType2["SHORT_ENTER"] = `short_enter`;
  PositionOrderType2["SHORT_EXIT"] = `short_exit`;
  return PositionOrderType2;
})(PositionOrderType || {});
var BaseSignalType = /* @__PURE__ */ ((BaseSignalType2) => {
  BaseSignalType2["ENTER"] = "enter" /* ENTER */;
  BaseSignalType2["CANDIDATE"] = "candidate";
  BaseSignalType2["TREND"] = "trend";
  BaseSignalType2["EXIT"] = "exit" /* EXIT */;
  return BaseSignalType2;
})(BaseSignalType || {});
var MarginMode = /* @__PURE__ */ ((MarginMode2) => {
  MarginMode2["CROSS"] = "cross";
  MarginMode2["ISOLATED"] = "isolated";
  return MarginMode2;
})(MarginMode || {});
var ExchangeType = /* @__PURE__ */ ((ExchangeType2) => {
  ExchangeType2["SPOT"] = "spot";
  ExchangeType2["FUTURE"] = "future";
  return ExchangeType2;
})(ExchangeType || {});
var AutoMode = /* @__PURE__ */ ((AutoMode2) => {
  AutoMode2["BOTH"] = "both";
  AutoMode2["ENTER"] = "enter";
  AutoMode2["EXIT"] = "exit";
  AutoMode2["MANUAL"] = "manual";
  return AutoMode2;
})(AutoMode || {});
const isAutoEnter = /* @__PURE__ */ __name((autoMode) => {
  return autoMode === "both" /* BOTH */ || autoMode === "enter" /* ENTER */;
}, "isAutoEnter");
const isAutoExit = /* @__PURE__ */ __name((autoMode) => {
  return autoMode === "both" /* BOTH */ || autoMode === "exit" /* EXIT */;
}, "isAutoExit");
var TriggerIgnoreReason = /* @__PURE__ */ ((TriggerIgnoreReason2) => {
  TriggerIgnoreReason2["IGNORED_BY_PRICE_CHANGE"] = "IGNORED_BY_PRICE_CHANGE";
  TriggerIgnoreReason2["IGNORED_BY_ORDER_TYPE"] = "IGNORED_BY_ORDER_TYPE";
  return TriggerIgnoreReason2;
})(TriggerIgnoreReason || {});
var CutType = /* @__PURE__ */ ((CutType2) => {
  CutType2["TAKE_PROFIT"] = "takeProfit";
  CutType2["STOP_LOSS"] = "stopLoss";
  return CutType2;
})(CutType || {});
var UpDown = /* @__PURE__ */ ((UpDown2) => {
  UpDown2["UP"] = "up";
  UpDown2["DOWN"] = "down";
  return UpDown2;
})(UpDown || {});
var NotifierType = /* @__PURE__ */ ((NotifierType2) => {
  NotifierType2["TELEGRAM"] = "telegram";
  NotifierType2["DISCORD"] = "discord";
  return NotifierType2;
})(NotifierType || {});
var InvestMode = /* @__PURE__ */ ((InvestMode2) => {
  InvestMode2["REAL"] = "real";
  InvestMode2["SIMULATION"] = "simulation";
  InvestMode2["BACKTEST"] = "backtest";
  return InvestMode2;
})(InvestMode || {});
var SearchInvestMode = /* @__PURE__ */ ((SearchInvestMode2) => {
  SearchInvestMode2["ALL"] = "all";
  SearchInvestMode2["REAL"] = "real" /* REAL */;
  SearchInvestMode2["SIMULATION"] = "simulation" /* SIMULATION */;
  SearchInvestMode2["BACKTEST"] = "backtest" /* BACKTEST */;
  SearchInvestMode2["NONE"] = "";
  return SearchInvestMode2;
})(SearchInvestMode || {});
var OrderMode = /* @__PURE__ */ ((OrderMode2) => {
  OrderMode2["REAL"] = "real" /* REAL */;
  OrderMode2["SIMULATION"] = "simulation" /* SIMULATION */;
  OrderMode2["BACKTEST"] = "backtest" /* BACKTEST */;
  OrderMode2["BACK_SIGNAL"] = "backSignal";
  return OrderMode2;
})(OrderMode || {});
var InvestListType = /* @__PURE__ */ ((InvestListType2) => {
  InvestListType2["REALTIME"] = "realtime";
  InvestListType2["BACKTEST"] = "backtest";
  return InvestListType2;
})(InvestListType || {});
var RunningMode = /* @__PURE__ */ ((RunningMode2) => {
  RunningMode2["RUNNING"] = "running";
  RunningMode2["STOPPED"] = "stopped";
  return RunningMode2;
})(RunningMode || {});
var AggregationType = /* @__PURE__ */ ((AggregationType2) => {
  AggregationType2["SUM"] = "sum";
  AggregationType2["AVG"] = "avg";
  AggregationType2["MAX"] = "max";
  AggregationType2["MIN"] = "min";
  return AggregationType2;
})(AggregationType || {});
var MathOperatorType = /* @__PURE__ */ ((MathOperatorType2) => {
  MathOperatorType2["ADD"] = "add";
  MathOperatorType2["SUB"] = "sub";
  MathOperatorType2["MUL"] = "mul";
  MathOperatorType2["DIV"] = "div";
  return MathOperatorType2;
})(MathOperatorType || {});
var ChangeRatioBy = /* @__PURE__ */ ((ChangeRatioBy2) => {
  ChangeRatioBy2["PRICE"] = "price";
  ChangeRatioBy2["ROE"] = "roe";
  return ChangeRatioBy2;
})(ChangeRatioBy || {});
var AmountRatioBy = /* @__PURE__ */ ((AmountRatioBy2) => {
  AmountRatioBy2["SIGNAL"] = "signal";
  AmountRatioBy2["CURRENT"] = "current";
  return AmountRatioBy2;
})(AmountRatioBy || {});
var TriggerTypeBase = /* @__PURE__ */ ((TriggerTypeBase2) => {
  TriggerTypeBase2["SIGNAL"] = "signal";
  TriggerTypeBase2["TRAILING"] = "trailing";
  TriggerTypeBase2["EXCLUSIVE"] = "exclusive";
  TriggerTypeBase2["OVERLAPPING"] = "overlapping";
  TriggerTypeBase2["FORCED"] = "forced";
  return TriggerTypeBase2;
})(TriggerTypeBase || {});
var TriggerType = /* @__PURE__ */ ((TriggerType2) => {
  TriggerType2["SIGNAL_ENTER"] = `signal_enter`;
  TriggerType2["SIGNAL_EXIT"] = `signal_exit`;
  TriggerType2["TRAILING_EXIT"] = `trailing_exit`;
  TriggerType2["EXCLUSIVE_EXIT"] = `exclusive_exit`;
  TriggerType2["OVERLAPPING_EXIT"] = `overlapping_exit`;
  TriggerType2["FORCED_EXIT"] = `forced_exit`;
  return TriggerType2;
})(TriggerType || {});
function getTriggerTypeBase(type) {
  return type.split("_")[0];
}
__name(getTriggerTypeBase, "getTriggerTypeBase");
var ForcedExitType = /* @__PURE__ */ ((ForcedExitType2) => {
  ForcedExitType2["ERROR"] = "error";
  ForcedExitType2["DURATION"] = "duration";
  ForcedExitType2["PROFIT_GOAL"] = "profitGoal";
  ForcedExitType2["LOSS_GOAL"] = "lossGoal";
  ForcedExitType2["TERMINATE"] = "terminate";
  ForcedExitType2["SUSPEND"] = "suspend";
  ForcedExitType2["STOP"] = "stop";
  ForcedExitType2["EXPIRED"] = "expired";
  ForcedExitType2["SESSION_TRIGGER"] = "sessionTrigger";
  ForcedExitType2["LIQUIDATION"] = "liquidation";
  return ForcedExitType2;
})(ForcedExitType || {});
const UserTriggerTypes = [
  "signal_enter" /* SIGNAL_ENTER */,
  "signal_exit" /* SIGNAL_EXIT */,
  "trailing_exit" /* TRAILING_EXIT */,
  "exclusive_exit" /* EXCLUSIVE_EXIT */,
  "overlapping_exit" /* OVERLAPPING_EXIT */
];
const TriggerTypeBases = {
  ["signal_enter" /* SIGNAL_ENTER */]: "signal" /* SIGNAL */,
  ["signal_exit" /* SIGNAL_EXIT */]: "signal" /* SIGNAL */,
  ["trailing_exit" /* TRAILING_EXIT */]: "trailing" /* TRAILING */,
  ["exclusive_exit" /* EXCLUSIVE_EXIT */]: "exclusive" /* EXCLUSIVE */,
  ["overlapping_exit" /* OVERLAPPING_EXIT */]: "overlapping" /* OVERLAPPING */
};
function isSignalTriggerType(type) {
  return ["signal_enter" /* SIGNAL_ENTER */, "signal_exit" /* SIGNAL_EXIT */].includes(type);
}
__name(isSignalTriggerType, "isSignalTriggerType");
var AverageUnitType = /* @__PURE__ */ ((AverageUnitType2) => {
  AverageUnitType2["SECOND"] = "second";
  AverageUnitType2["MINUTE"] = "minute";
  return AverageUnitType2;
})(AverageUnitType || {});
var SaveAsType = /* @__PURE__ */ ((SaveAsType2) => {
  SaveAsType2["SAVE"] = "save";
  SaveAsType2["SAVE_AS"] = "saveAs";
  SaveAsType2["NEW_SAVE"] = "newSave";
  return SaveAsType2;
})(SaveAsType || {});
var TaFunctionId = /* @__PURE__ */ ((TaFunctionId2) => {
  TaFunctionId2[TaFunctionId2["NA"] = 0] = "NA";
  TaFunctionId2[TaFunctionId2["BBANDS"] = 1] = "BBANDS";
  TaFunctionId2[TaFunctionId2["DEMA"] = 2] = "DEMA";
  TaFunctionId2[TaFunctionId2["EMA"] = 3] = "EMA";
  TaFunctionId2[TaFunctionId2["HT_TRENDLINE"] = 4] = "HT_TRENDLINE";
  TaFunctionId2[TaFunctionId2["KAMA"] = 5] = "KAMA";
  TaFunctionId2[TaFunctionId2["MA"] = 6] = "MA";
  TaFunctionId2[TaFunctionId2["MAMA"] = 7] = "MAMA";
  TaFunctionId2[TaFunctionId2["MAVP"] = 8] = "MAVP";
  TaFunctionId2[TaFunctionId2["MIDPOINT"] = 9] = "MIDPOINT";
  TaFunctionId2[TaFunctionId2["MIDPRICE"] = 10] = "MIDPRICE";
  TaFunctionId2[TaFunctionId2["SAR"] = 11] = "SAR";
  TaFunctionId2[TaFunctionId2["SAREXT"] = 12] = "SAREXT";
  TaFunctionId2[TaFunctionId2["SMA"] = 13] = "SMA";
  TaFunctionId2[TaFunctionId2["T3"] = 14] = "T3";
  TaFunctionId2[TaFunctionId2["TEMA"] = 15] = "TEMA";
  TaFunctionId2[TaFunctionId2["TRIMA"] = 16] = "TRIMA";
  TaFunctionId2[TaFunctionId2["WMA"] = 17] = "WMA";
  TaFunctionId2[TaFunctionId2["ADX"] = 18] = "ADX";
  TaFunctionId2[TaFunctionId2["ADXR"] = 19] = "ADXR";
  TaFunctionId2[TaFunctionId2["APO"] = 20] = "APO";
  TaFunctionId2[TaFunctionId2["AROON"] = 21] = "AROON";
  TaFunctionId2[TaFunctionId2["AROONOSC"] = 22] = "AROONOSC";
  TaFunctionId2[TaFunctionId2["BOP"] = 23] = "BOP";
  TaFunctionId2[TaFunctionId2["CCI"] = 24] = "CCI";
  TaFunctionId2[TaFunctionId2["CMO"] = 25] = "CMO";
  TaFunctionId2[TaFunctionId2["DX"] = 26] = "DX";
  TaFunctionId2[TaFunctionId2["MACD"] = 27] = "MACD";
  TaFunctionId2[TaFunctionId2["MACDEXT"] = 28] = "MACDEXT";
  TaFunctionId2[TaFunctionId2["MACDFIX"] = 29] = "MACDFIX";
  TaFunctionId2[TaFunctionId2["MFI"] = 30] = "MFI";
  TaFunctionId2[TaFunctionId2["MINUS_DI"] = 31] = "MINUS_DI";
  TaFunctionId2[TaFunctionId2["MINUS_DM"] = 32] = "MINUS_DM";
  TaFunctionId2[TaFunctionId2["MOM"] = 33] = "MOM";
  TaFunctionId2[TaFunctionId2["PLUS_DI"] = 34] = "PLUS_DI";
  TaFunctionId2[TaFunctionId2["PLUS_DM"] = 35] = "PLUS_DM";
  TaFunctionId2[TaFunctionId2["PPO"] = 36] = "PPO";
  TaFunctionId2[TaFunctionId2["ROC"] = 37] = "ROC";
  TaFunctionId2[TaFunctionId2["ROCP"] = 38] = "ROCP";
  TaFunctionId2[TaFunctionId2["ROCR"] = 39] = "ROCR";
  TaFunctionId2[TaFunctionId2["ROCR100"] = 40] = "ROCR100";
  TaFunctionId2[TaFunctionId2["RSI"] = 41] = "RSI";
  TaFunctionId2[TaFunctionId2["STOCH"] = 42] = "STOCH";
  TaFunctionId2[TaFunctionId2["STOCH_2"] = 43] = "STOCH_2";
  TaFunctionId2[TaFunctionId2["STOCHF"] = 44] = "STOCHF";
  TaFunctionId2[TaFunctionId2["STOCHRSI"] = 45] = "STOCHRSI";
  TaFunctionId2[TaFunctionId2["TRIX"] = 46] = "TRIX";
  TaFunctionId2[TaFunctionId2["ULTOSC"] = 47] = "ULTOSC";
  TaFunctionId2[TaFunctionId2["WILLR"] = 48] = "WILLR";
  TaFunctionId2[TaFunctionId2["HT_DCPERIOD"] = 49] = "HT_DCPERIOD";
  TaFunctionId2[TaFunctionId2["HT_DCPHASE"] = 50] = "HT_DCPHASE";
  TaFunctionId2[TaFunctionId2["HT_PHASOR"] = 51] = "HT_PHASOR";
  TaFunctionId2[TaFunctionId2["HT_SINE"] = 52] = "HT_SINE";
  TaFunctionId2[TaFunctionId2["HT_TRENDMODE"] = 53] = "HT_TRENDMODE";
  TaFunctionId2[TaFunctionId2["AD"] = 54] = "AD";
  TaFunctionId2[TaFunctionId2["ADOSC"] = 55] = "ADOSC";
  TaFunctionId2[TaFunctionId2["OBV"] = 56] = "OBV";
  TaFunctionId2[TaFunctionId2["CDL2CROWS"] = 57] = "CDL2CROWS";
  TaFunctionId2[TaFunctionId2["CDL3BLACKCROWS"] = 58] = "CDL3BLACKCROWS";
  TaFunctionId2[TaFunctionId2["CDL3INSIDE"] = 59] = "CDL3INSIDE";
  TaFunctionId2[TaFunctionId2["CDL3LINESTRIKE"] = 60] = "CDL3LINESTRIKE";
  TaFunctionId2[TaFunctionId2["CDL3OUTSIDE"] = 61] = "CDL3OUTSIDE";
  TaFunctionId2[TaFunctionId2["CDL3STARSINSOUTH"] = 62] = "CDL3STARSINSOUTH";
  TaFunctionId2[TaFunctionId2["CDL3WHITESOLDIERS"] = 63] = "CDL3WHITESOLDIERS";
  TaFunctionId2[TaFunctionId2["CDLABANDONEDBABY"] = 64] = "CDLABANDONEDBABY";
  TaFunctionId2[TaFunctionId2["CDLADVANCEBLOCK"] = 65] = "CDLADVANCEBLOCK";
  TaFunctionId2[TaFunctionId2["CDLBELTHOLD"] = 66] = "CDLBELTHOLD";
  TaFunctionId2[TaFunctionId2["CDLBREAKAWAY"] = 67] = "CDLBREAKAWAY";
  TaFunctionId2[TaFunctionId2["CDLCLOSINGMARUBOZU"] = 68] = "CDLCLOSINGMARUBOZU";
  TaFunctionId2[TaFunctionId2["CDLCONCEALBABYSWALL"] = 69] = "CDLCONCEALBABYSWALL";
  TaFunctionId2[TaFunctionId2["CDLCOUNTERATTACK"] = 70] = "CDLCOUNTERATTACK";
  TaFunctionId2[TaFunctionId2["CDLDARKCLOUDCOVER"] = 71] = "CDLDARKCLOUDCOVER";
  TaFunctionId2[TaFunctionId2["CDLDOJI"] = 72] = "CDLDOJI";
  TaFunctionId2[TaFunctionId2["CDLDOJISTAR"] = 73] = "CDLDOJISTAR";
  TaFunctionId2[TaFunctionId2["CDLDRAGONFLYDOJI"] = 74] = "CDLDRAGONFLYDOJI";
  TaFunctionId2[TaFunctionId2["CDLENGULFING"] = 75] = "CDLENGULFING";
  TaFunctionId2[TaFunctionId2["CDLEVENINGDOJISTAR"] = 76] = "CDLEVENINGDOJISTAR";
  TaFunctionId2[TaFunctionId2["CDLEVENINGSTAR"] = 77] = "CDLEVENINGSTAR";
  TaFunctionId2[TaFunctionId2["CDLGAPSIDESIDEWHITE"] = 78] = "CDLGAPSIDESIDEWHITE";
  TaFunctionId2[TaFunctionId2["CDLGRAVESTONEDOJI"] = 79] = "CDLGRAVESTONEDOJI";
  TaFunctionId2[TaFunctionId2["CDLHAMMER"] = 80] = "CDLHAMMER";
  TaFunctionId2[TaFunctionId2["CDLHANGINGMAN"] = 81] = "CDLHANGINGMAN";
  TaFunctionId2[TaFunctionId2["CDLHARAMI"] = 82] = "CDLHARAMI";
  TaFunctionId2[TaFunctionId2["CDLHARAMICROSS"] = 83] = "CDLHARAMICROSS";
  TaFunctionId2[TaFunctionId2["CDLHIGHWAVE"] = 84] = "CDLHIGHWAVE";
  TaFunctionId2[TaFunctionId2["CDLHIKKAKE"] = 85] = "CDLHIKKAKE";
  TaFunctionId2[TaFunctionId2["CDLHIKKAKEMOD"] = 86] = "CDLHIKKAKEMOD";
  TaFunctionId2[TaFunctionId2["CDLHOMINGPIGEON"] = 87] = "CDLHOMINGPIGEON";
  TaFunctionId2[TaFunctionId2["CDLIDENTICAL3CROWS"] = 88] = "CDLIDENTICAL3CROWS";
  TaFunctionId2[TaFunctionId2["CDLINNECK"] = 89] = "CDLINNECK";
  TaFunctionId2[TaFunctionId2["CDLINVERTEDHAMMER"] = 90] = "CDLINVERTEDHAMMER";
  TaFunctionId2[TaFunctionId2["CDLKICKING"] = 91] = "CDLKICKING";
  TaFunctionId2[TaFunctionId2["CDLKICKINGBYLENGTH"] = 92] = "CDLKICKINGBYLENGTH";
  TaFunctionId2[TaFunctionId2["CDLLADDERBOTTOM"] = 93] = "CDLLADDERBOTTOM";
  TaFunctionId2[TaFunctionId2["CDLLONGLEGGEDDOJI"] = 94] = "CDLLONGLEGGEDDOJI";
  TaFunctionId2[TaFunctionId2["CDLLONGLINE"] = 95] = "CDLLONGLINE";
  TaFunctionId2[TaFunctionId2["CDLMARUBOZU"] = 96] = "CDLMARUBOZU";
  TaFunctionId2[TaFunctionId2["CDLMATCHINGLOW"] = 97] = "CDLMATCHINGLOW";
  TaFunctionId2[TaFunctionId2["CDLMATHOLD"] = 98] = "CDLMATHOLD";
  TaFunctionId2[TaFunctionId2["CDLMORNINGDOJISTAR"] = 99] = "CDLMORNINGDOJISTAR";
  TaFunctionId2[TaFunctionId2["CDLMORNINGSTAR"] = 100] = "CDLMORNINGSTAR";
  TaFunctionId2[TaFunctionId2["CDLONNECK"] = 101] = "CDLONNECK";
  TaFunctionId2[TaFunctionId2["CDLPIERCING"] = 102] = "CDLPIERCING";
  TaFunctionId2[TaFunctionId2["CDLRICKSHAWMAN"] = 103] = "CDLRICKSHAWMAN";
  TaFunctionId2[TaFunctionId2["CDLRISEFALL3METHODS"] = 104] = "CDLRISEFALL3METHODS";
  TaFunctionId2[TaFunctionId2["CDLSEPARATINGLINES"] = 105] = "CDLSEPARATINGLINES";
  TaFunctionId2[TaFunctionId2["CDLSHOOTINGSTAR"] = 106] = "CDLSHOOTINGSTAR";
  TaFunctionId2[TaFunctionId2["CDLSHORTLINE"] = 107] = "CDLSHORTLINE";
  TaFunctionId2[TaFunctionId2["CDLSPINNINGTOP"] = 108] = "CDLSPINNINGTOP";
  TaFunctionId2[TaFunctionId2["CDLSTALLEDPATTERN"] = 109] = "CDLSTALLEDPATTERN";
  TaFunctionId2[TaFunctionId2["CDLSTICKSANDWICH"] = 110] = "CDLSTICKSANDWICH";
  TaFunctionId2[TaFunctionId2["CDLTAKURI"] = 111] = "CDLTAKURI";
  TaFunctionId2[TaFunctionId2["CDLTASUKIGAP"] = 112] = "CDLTASUKIGAP";
  TaFunctionId2[TaFunctionId2["CDLTHRUSTING"] = 113] = "CDLTHRUSTING";
  TaFunctionId2[TaFunctionId2["CDLTRISTAR"] = 114] = "CDLTRISTAR";
  TaFunctionId2[TaFunctionId2["CDLUNIQUE3RIVER"] = 115] = "CDLUNIQUE3RIVER";
  TaFunctionId2[TaFunctionId2["CDLUPSIDEGAP2CROWS"] = 116] = "CDLUPSIDEGAP2CROWS";
  TaFunctionId2[TaFunctionId2["CDLXSIDEGAP3METHODS"] = 117] = "CDLXSIDEGAP3METHODS";
  TaFunctionId2[TaFunctionId2["DMI"] = 118] = "DMI";
  TaFunctionId2[TaFunctionId2["SUPERTREND"] = 119] = "SUPERTREND";
  TaFunctionId2[TaFunctionId2["WAVETREND"] = 120] = "WAVETREND";
  TaFunctionId2[TaFunctionId2["ICHIMOKU_CLOUD"] = 121] = "ICHIMOKU_CLOUD";
  TaFunctionId2[TaFunctionId2["ADD"] = 122] = "ADD";
  TaFunctionId2[TaFunctionId2["DIV"] = 123] = "DIV";
  TaFunctionId2[TaFunctionId2["MAX"] = 124] = "MAX";
  TaFunctionId2[TaFunctionId2["MAXINDEX"] = 125] = "MAXINDEX";
  TaFunctionId2[TaFunctionId2["MIN"] = 126] = "MIN";
  TaFunctionId2[TaFunctionId2["MININDEX"] = 127] = "MININDEX";
  TaFunctionId2[TaFunctionId2["MINMAX"] = 128] = "MINMAX";
  TaFunctionId2[TaFunctionId2["MINMAXINDEX"] = 129] = "MINMAXINDEX";
  TaFunctionId2[TaFunctionId2["MULT"] = 130] = "MULT";
  TaFunctionId2[TaFunctionId2["SUB"] = 131] = "SUB";
  TaFunctionId2[TaFunctionId2["SUM"] = 132] = "SUM";
  TaFunctionId2[TaFunctionId2["ACOS"] = 133] = "ACOS";
  TaFunctionId2[TaFunctionId2["ASIN"] = 134] = "ASIN";
  TaFunctionId2[TaFunctionId2["ATAN"] = 135] = "ATAN";
  TaFunctionId2[TaFunctionId2["CEIL"] = 136] = "CEIL";
  TaFunctionId2[TaFunctionId2["COS"] = 137] = "COS";
  TaFunctionId2[TaFunctionId2["COSH"] = 138] = "COSH";
  TaFunctionId2[TaFunctionId2["EXP"] = 139] = "EXP";
  TaFunctionId2[TaFunctionId2["FLOOR"] = 140] = "FLOOR";
  TaFunctionId2[TaFunctionId2["LN"] = 141] = "LN";
  TaFunctionId2[TaFunctionId2["LOG10"] = 142] = "LOG10";
  TaFunctionId2[TaFunctionId2["SIN"] = 143] = "SIN";
  TaFunctionId2[TaFunctionId2["SINH"] = 144] = "SINH";
  TaFunctionId2[TaFunctionId2["SQRT"] = 145] = "SQRT";
  TaFunctionId2[TaFunctionId2["TAN"] = 146] = "TAN";
  TaFunctionId2[TaFunctionId2["TANH"] = 147] = "TANH";
  TaFunctionId2[TaFunctionId2["ATR"] = 148] = "ATR";
  TaFunctionId2[TaFunctionId2["NATR"] = 149] = "NATR";
  TaFunctionId2[TaFunctionId2["TRANGE"] = 150] = "TRANGE";
  TaFunctionId2[TaFunctionId2["BETA"] = 151] = "BETA";
  TaFunctionId2[TaFunctionId2["CORREL"] = 152] = "CORREL";
  TaFunctionId2[TaFunctionId2["LINEARREG"] = 153] = "LINEARREG";
  TaFunctionId2[TaFunctionId2["LINEARREG_ANGLE"] = 154] = "LINEARREG_ANGLE";
  TaFunctionId2[TaFunctionId2["LINEARREG_INTERCEPT"] = 155] = "LINEARREG_INTERCEPT";
  TaFunctionId2[TaFunctionId2["LINEARREG_SLOPE"] = 156] = "LINEARREG_SLOPE";
  TaFunctionId2[TaFunctionId2["STDDEV"] = 157] = "STDDEV";
  TaFunctionId2[TaFunctionId2["TSF"] = 158] = "TSF";
  TaFunctionId2[TaFunctionId2["VAR"] = 159] = "VAR";
  TaFunctionId2[TaFunctionId2["AVGPRICE"] = 160] = "AVGPRICE";
  TaFunctionId2[TaFunctionId2["MEDPRICE"] = 161] = "MEDPRICE";
  TaFunctionId2[TaFunctionId2["TYPPRICE"] = 162] = "TYPPRICE";
  TaFunctionId2[TaFunctionId2["WCLPRICE"] = 163] = "WCLPRICE";
  TaFunctionId2[TaFunctionId2["IIIX"] = 164] = "IIIX";
  TaFunctionId2[TaFunctionId2["MAXOC"] = 165] = "MAXOC";
  TaFunctionId2[TaFunctionId2["MINOC"] = 166] = "MINOC";
  TaFunctionId2[TaFunctionId2["LINEAR_REGRESSION_CANDLES"] = 167] = "LINEAR_REGRESSION_CANDLES";
  TaFunctionId2[TaFunctionId2["STC_INDICATOR_A_BETTER_MACD"] = 168] = "STC_INDICATOR_A_BETTER_MACD";
  TaFunctionId2[TaFunctionId2["UT_BOT_ALERTS"] = 169] = "UT_BOT_ALERTS";
  TaFunctionId2[TaFunctionId2["NEGLECTED_VOLUME"] = 170] = "NEGLECTED_VOLUME";
  TaFunctionId2[TaFunctionId2["VPFR"] = 171] = "VPFR";
  TaFunctionId2[TaFunctionId2["MOBO"] = 172] = "MOBO";
  TaFunctionId2[TaFunctionId2["SSL_HYBRID"] = 173] = "SSL_HYBRID";
  TaFunctionId2[TaFunctionId2["VWAP_SA"] = 174] = "VWAP_SA";
  TaFunctionId2[TaFunctionId2["TAKER_BUY_SELL_VOLUME"] = 175] = "TAKER_BUY_SELL_VOLUME";
  TaFunctionId2[TaFunctionId2["WAVE"] = 176] = "WAVE";
  TaFunctionId2[TaFunctionId2["VOLUME"] = 177] = "VOLUME";
  return TaFunctionId2;
})(TaFunctionId || {});
export {
  AggregationType,
  AlertFrequencyType,
  AmountRatioBy,
  AutoMode,
  AverageUnitType,
  BaseSignalType,
  CandleComputedType,
  CandleConditionTypes,
  CandleValueType,
  ChangeRatioBy,
  CompareResultType,
  ConditionOperatorType,
  CutType,
  EditMode,
  ExchangeType,
  ForcedExitType,
  IndicatorOrCondition,
  IndicatorSeriesType,
  InvestListType,
  InvestMode,
  MAType,
  MarginMode,
  MarketTypeCcxt,
  MathOperatorType,
  NotifierType,
  OhlcvIndex,
  OperandSourceType,
  OrderMode,
  OrderSideCcxt,
  OrderType,
  OrderTypeCcxt,
  PositionOrderType,
  PositionType,
  RunningMode,
  SaveAsType,
  SearchInvestMode,
  SourceIndex,
  StrategyDisplayMode,
  SubTypeCcxt,
  TaFunctionId,
  TakerOrMaker,
  TriggerIgnoreReason,
  TriggerType,
  TriggerTypeBase,
  TriggerTypeBases,
  UpDown,
  UserTriggerTypes,
  getMaTypeName,
  getTriggerTypeBase,
  isAutoEnter,
  isAutoExit,
  isCandleComputedType,
  isCandleValueType,
  isSignalTriggerType
};
//# sourceMappingURL=enum.js.map
